<template>
  <CurtainConfigurator />
</template>

<script>
import CurtainConfigurator from './components/CurtainConfigurator.vue'

export default {
  name: 'App',
  components: {
    CurtainConfigurator
  }
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  min-width: 320px;
  min-height: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, "Microsoft YaHei", sans-serif;
}

* {
  box-sizing: border-box;
}

body {
  background: #e3e2dc;
}

button,
input {
  font-family: inherit;
}
</style>
